import { FC, useMemo } from 'react';
import { StarOutlined } from '@ant-design/icons';
import { FirstBuysChartProps } from '../../../../../../core/domain/overview/first-buys';
import { ChartCard } from '../../components/chart-card/chart-card';
import { AreaSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: FirstBuysChartProps;
    chartLoading: boolean;
}

const series = [{ key: 'value', name: 'خرید های اول', color: CHART_COLORS.amber }];

export const FirstBuys: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(() => mergeByDate([{ key: 'value', data: chartData?.firstBuyUsers }]), [chartData]);

    return (
        <ChartCard
            title="خرید های اول"
            subtitle="کاربرانی که اولین خرید خود را ثبت کرده‌اند"
            icon={<StarOutlined />}
            accent="amber"
            loading={chartLoading}
            empty={!data.length}
            wide
            stats={[{ label: 'مجموع بازه', value: faNumber(sumOf(data, 'value')), color: CHART_COLORS.amber }]}
        >
            <AreaSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
